import React from 'react';
import classNames from 'classnames';
import { CSpacing, NativeProps } from '@/src/components/interfaces';

export enum CDividerOrientation {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}

export enum CDividerColor {
  Dark = 'dark',
  Medium = 'medium',
  Light = 'light',
}

export interface CDividerProps extends NativeProps {
  orientation?: CDividerOrientation;
  marginVertical?: CSpacing;
  marginHorizontal?: CSpacing;
  color?: CDividerColor;
}

export function CDivider(props: CDividerProps): React.JSX.Element {
  const orientation = props.orientation ?? CDividerOrientation.Horizontal;
  const marginVertical = props.marginVertical ?? CSpacing.Md;
  const marginHorizontal = props.marginHorizontal ?? CSpacing.None;
  const color = props.color ?? CDividerColor.Medium;

  return (
    <div
      className={classNames('c-divider', {
        [`c-divider--orientation-${orientation}`]: orientation,
        [`c-margin--vertical--${marginVertical}`]: marginVertical !== CSpacing.None,
        [`c-margin--horizontal--${marginHorizontal}`]: marginHorizontal !== CSpacing.None,
        [`c-divider--color-${color}`]: color,
      }, props.class)}
      id={props.id}
      data-test-selector={props.testSelector}
    />
  );
}